import { queryDatabaseItems } from "../../../services/database/queryDatabaseItems";
import { Slide } from "../types/slideTypes";

export async function querySlides(lessonId: string) {
  const slides = await queryDatabaseItems<Slide>("/slides", lessonId);

  return slides.sort((a, b) => a.orderIndex - b.orderIndex);
}
